export default __webpack_public_path__ + "static/media/auth-protiv-logo.42f85a7a.svg";